// extracted by mini-css-extract-plugin
module.exports = {"curatorCard":"_5uFjA","buttons":"zAiCk","curatorName":"t-Vwc","showed":"CUccn","curatorButton":"dQHrf"};